import script from "./DishwasherScheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./DishwasherScheduler.vue?vue&type=script&setup=true&lang=js"

import "./DishwasherScheduler.vue?vue&type=style&index=0&id=712cfa4e&lang=css"

const __exports__ = script;

export default __exports__